import { Log, useTranslation } from '@fanfanlo';
import { Box, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { MessageInput } from './MessageInput';
import { MessageListVirtuoso } from './MessageListVirtuoso';
import { RoomHeader } from './RoomHeader';

const fileLogger = new Log(false, 'im.components.room.RoomContent2');
// fileLogger.pause = true;

interface RoomContent2Props {
  roomId: string;
}

export function RoomContent({ roomId }: RoomContent2Props) {
  const logger = fileLogger.sub(false, 'RoomContent2');
  // logger.pause = true;
  
  const { t } = useTranslation('homepage/im/components/room/content');
  const theme = useTheme();
  const [showMembers, setShowMembers] = useState(false);
  const router = useRouter();
  
  const topBarRef = useRef<HTMLDivElement>(null);
  const bottomBarRef = useRef<HTMLDivElement>(null);
  const [bottomBarHeight, setBottomBarHeight] = useState(0);
  const [topBarHeight, setTopBarHeight] = useState(0);

  useEffect(() => {
    if (bottomBarRef.current) {
      setBottomBarHeight(bottomBarRef.current.offsetHeight);
    }
  }, [bottomBarRef.current]);

  useEffect(() => {
    if (topBarRef.current) {
      setTopBarHeight(topBarRef.current.offsetHeight);
    }
  }, [topBarRef.current]);

  // 滚动到底部
  const scrollToBottom = useCallback(() => {
    // 由于移除了 MessageListScroller，这里暂时留空
    // 后续可以实现自定义滚动逻辑
  }, []);

  // 切换成员面板
  const toggleMembers = useCallback(() => {
    setShowMembers(prev => !prev);
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* 顶部 AppBar */}
      <Box
        ref={topBarRef}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          padding: '10px',
          borderBottom: '1px solid #ccc',
          zIndex: 1,
        }}>
        <RoomHeader roomId={roomId} onToggleMembers={toggleMembers} showMembers={showMembers} />
      </Box>

      {/* 中间内容区域 - 测试消息列表 */}
      <div style={{
        position: 'fixed',
        top: `${topBarHeight}px`,
        left: 0,
        right: 0,
        bottom: `${bottomBarHeight}px`,
        backgroundColor: '#f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1000,
        overflow: 'hidden',
        border: '1px solid white'
      }}>
        {/* 测试标题 */}
        {/* <div style={{
          padding: '10px',
          backgroundColor: '#e0e0e0',
          borderBottom: '1px solid #ccc',
          fontWeight: 'bold'
        }}>
          消息列表测试区域
        </div> */}
        
        {/* 消息列表容器 */}
        <div style={{
          flex: 1,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          backgroundColor: '#fafafa',
          padding: '10px'
        }}>
          <MessageListVirtuoso roomId={roomId} />
        </div>
        
        {/* 调试信息 */}
        {/* <div style={{
          padding: '5px',
          fontSize: '12px',
          color: '#666',
          backgroundColor: '#f8f8f8',
          borderTop: '1px solid #ddd'
        }}>
          容器高度: {`calc(100vh - ${topBarHeight + bottomBarHeight}px)`}
        </div> */}
      </div>

      {/* 底部 BottomBar */}
      <Box
        ref={bottomBarRef}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          padding: '10px',
          borderTop: '1px solid #ccc',
          zIndex: 1,
        }}>
        <MessageInput roomId={roomId} />
      </Box>
    </Box>
  );
}